<script>
export default {
  name: 'BaseTag',
  props: {
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    xSmall: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<template>
  <v-chip
    :color="color"
    :outlined="outlined"
    :x-small="xSmall"
    :small="small"
    :dark="dark"
    :close="closable"
    v-bind="$attrs"
    v-on="$listeners"
    @click:close="onClose"
  >
    <slot>{{ text }}</slot>
  </v-chip>
</template>
